import React from "react";
import AIChatIntegrationsControl from "ce/components/formControls/AIChatIntegrationsControl";
import AIChatIntegrations from "./AIChatIntegrations";
import { Field } from "redux-form";

class EEAIChatIntegrationsControl extends AIChatIntegrationsControl {
  render() {
    return (
      <Field
        component={AIChatIntegrations}
        formName={this.props.formName}
        name={this.props.configProperty}
      />
    );
  }
}

export default EEAIChatIntegrationsControl;
